import { Alert, Button, Card } from "react-bootstrap";
import { Info, Package } from "react-feather";
import toast from "react-hot-toast";

import ModalGeneric from "../../../../components/ModalGeneric";
import Table from "../.././../../components/tables/Table";

import shipmentService from "../../../../services/shipmentService";

import rackItemsTableColumns from "./rackItemsTableColumns";

const ShipmentRackItems = ({ selectedShipmentRack }) => {
  const changeRackToOversize = async () => {
    // Check to see if the shipment category of the rack is already oversize.
    if (selectedShipmentRack.shipmentCategoryId === 2) {
      toast.error(
        `Shipment Rack ${selectedShipmentRack.shipmentRackId} is already Oversize.`
      );
      return;
    }

    try {
      await shipmentService.changeRackToOversizeCategory(
        selectedShipmentRack.shipmentRackId
      );

      toast.success(`Rack was changed to be Oversize`);
    } catch (error) {
      console.log(error);
      toast.error(`Unable to change rack to Oversize`);
    }
  };

  return (
    <Card className="sticky-top" style={{ top: 20 }}>
      <Card.Header>
        <div className="d-flex">
          <div className="me-auto d-flex justify-content-start">
            <Package size="40" className="me-3" />
            <div>
              <Card.Title>
                Shipment Rack {selectedShipmentRack.shipmentRackId}
              </Card.Title>
              {selectedShipmentRack.shipmentRackItems && (
                <Card.Subtitle>
                  {selectedShipmentRack.shipmentRackItems.length} Items
                </Card.Subtitle>
              )}
            </div>
          </div>
          <div className="mx-2">
            {selectedShipmentRack.shipmentRackStatusId !== 4 &&
              selectedShipmentRack.shipmentCategoryId !== 2 && (
                <ModalGeneric
                  trigger={<Button>Change Rack to Oversize</Button>}
                  body={`Change Shipment Rack ${selectedShipmentRack.shipmentRackId} from standard to oversize?`}
                  actionButtonCallback={changeRackToOversize}
                />
              )}
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        {selectedShipmentRack.shipmentRackItems &&
        selectedShipmentRack.shipmentRackItems.length > 0 ? (
          <Table
            columns={rackItemsTableColumns}
            data={selectedShipmentRack.shipmentRackItems}
          />
        ) : (
          <Alert variant="warning">
            <div className="alert-icon">
              <Info
                className="position-relative top-50 start-50 translate-middle"
                size={20}
              />
            </div>
            <div className="alert-message d-flex justify-content-between align-items-center">
              <span>
                There are no items on Shipment Rack{" "}
                <strong>{selectedShipmentRack.shipmentRackId}</strong>. Try
                selecting a different Shipment Rack to view Shipment Rack Items.
              </span>
            </div>
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default ShipmentRackItems;
